import { render, staticRenderFns } from "./FullScreenLogin.vue?vue&type=template&id=52ea9f16"
import script from "./FullScreenLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenLogin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FullScreenLogin.vue?vue&type=style&index=0&id=52ea9f16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports